import React from "react";
import classNames from "classnames";
import { FormGroup, Label, ButtonGroup, Button } from "reactstrap";
import styles from "./RadioButtonGroup.module.scss";
const RadioButtonGroup = props => {
  const { options, color, clearButtonLabel, canToggle, input = {}, small, label, id, className, meta, ...rest } = props;
  return (
    <FormGroup className={classNames({ 'm-0': small })}>
      {!small && label && <Label>{label}</Label>}
      <ButtonGroup id={id} className={classNames(styles.root, className, 'd-flex', { [styles.smaller]: small })}  {...rest}>
        {Object.keys(options).map(key => (
          <Button
            key={key}
            onClick={() => {
              if (!canToggle || key !== input.value){
                input.onChange(key)
              }
              if(canToggle && key === input.value){
                input.onChange(null)
              }
            }}
            outline={key !== input.value}
            color={color || 'primary'}
            className="text-nowrap"
          >
            {options[key].label}
          </Button>
        ))}
        {clearButtonLabel &&
          <Button
            onClick={() => input.onChange(null)}
            outline={!!input.value}
            color={color || 'primary'}
            className="text-nowrap"
          >
            {clearButtonLabel}
          </Button>
        }
      </ButtonGroup>
    </FormGroup>
  )
}

export default RadioButtonGroup;